import React, { useEffect, useState, useRef, lazy, createElement } from 'react';
import { useVideo } from './VideoContext';
import { PlayIcon, ChevronDownIcon } from 'lucide-react';
const featuredWorks = [{
  id: 'Epznj_VSFpQ',
  title: 'NPO Zapp - Sinterklaas Journaal Intro 2025',
  thumbnail: 'https://img.youtube.com/vi/Epznj_VSFpQ/maxresdefault.jpg',
  category: 'Series & Films'
}, {
  id: 's3hlipr-5YY',
  title: 'Dertigers S6 | BNNVARA | NPO Start',
  thumbnail: 'https://img.youtube.com/vi/s3hlipr-5YY/maxresdefault.jpg',
  category: 'Series & Films'
}, {
  id: 'rVgYwUvqnIE',
  title: 'Sleepers seizoen 3 | Trailer | Vanaf 12 december',
  thumbnail: 'https://img.youtube.com/vi/rVgYwUvqnIE/maxresdefault.jpg',
  category: 'Series & Films'
}, {
  id: 'eyHSH4AmlQg',
  title: 'Timmy Trumpet x Jebroer x Dr Phunk - Child Of The Devil',
  thumbnail: 'https://img.youtube.com/vi/eyHSH4AmlQg/maxresdefault.jpg',
  category: 'Videoclips'
}, {
  id: 'xqAqaLV8Nf4',
  title: 'Lucas & Steve - Up Till Dawn (On The Move)',
  thumbnail: 'https://img.youtube.com/vi/xqAqaLV8Nf4/maxresdefault.jpg',
  category: 'Videoclips'
}, {
  id: 'sxQ3F_-3UEc',
  title: 'FeestDJRuud - Lonely at the Tap (OFFICIAL VIDEO)',
  thumbnail: 'https://img.youtube.com/vi/sxQ3F_-3UEc/maxresdefault.jpg',
  category: 'Videoclips'
}, {
  id: 'Ku0TR4rvYTk',
  title: 'ULTRA EUROPE 2025 - Official Aftermovie',
  thumbnail: 'https://img.youtube.com/vi/Ku0TR4rvYTk/maxresdefault.jpg',
  category: 'Commercials / Festivals'
}, {
  id: 'JjZs8Do2HgQ',
  title: 'PAROOKAVILLE 2025 | OFFICIAL AFTERMOVIE',
  thumbnail: 'https://img.youtube.com/vi/JjZs8Do2HgQ/maxresdefault.jpg',
  category: 'Commercials / Festivals'
}, {
  id: 'x5CCGe3rt4o',
  title: 'Dertigers: de kerstfilm',
  thumbnail: 'https://img.youtube.com/vi/x5CCGe3rt4o/maxresdefault.jpg',
  category: 'Series & Films'
}];
export const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(() => Math.floor(Math.random() * featuredWorks.length));
  const [isHovering, setIsHovering] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isReducedMotion, setIsReducedMotion] = useState(false);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const {
    openVideo
  } = useVideo();
  const videoRef = useRef<HTMLVideoElement>(null);
  const rainRef = useRef<HTMLDivElement>(null);
  const logoRef = useRef<HTMLDivElement>(null);
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    const checkReducedMotion = () => {
      setIsReducedMotion(window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    };
    checkIfMobile();
    checkReducedMotion();
    window.addEventListener('resize', checkIfMobile);
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);
  useEffect(() => {
    setIsVisible(true);
    let interval = null;
    if (!isHovering) {
      interval = setInterval(() => {
        setActiveIndex(prev => (prev + 1) % featuredWorks.length);
      }, 5000);
    }
    if (rainRef.current && !isMobile && !isReducedMotion) {
      createRaindrops(rainRef.current);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isHovering, isMobile, isReducedMotion]);
  const createRaindrops = container => {
    container.innerHTML = '';
    const numberOfDrops = 30;
    for (let i = 0; i < numberOfDrops; i++) {
      const drop = document.createElement('div');
      drop.className = 'raindrop';
      const size = Math.random() * 0.8 + 0.3;
      const posX = Math.random() * 100;
      const delay = Math.random() * 3;
      const duration = Math.random() * 1 + 2;
      drop.style.width = `${size}px`;
      drop.style.left = `${posX}%`;
      drop.style.animationDelay = `${delay}s`;
      drop.style.animationDuration = `${duration}s`;
      drop.style.opacity = '0.1';
      container.appendChild(drop);
    }
  };
  const handleTouchStart = e => {
    setTouchStart(e.targetTouches[0].clientX);
  };
  const handleTouchMove = e => {
    setTouchEnd(e.targetTouches[0].clientX);
  };
  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;
    if (isLeftSwipe) {
      setActiveIndex(prev => (prev + 1) % featuredWorks.length);
    }
    if (isRightSwipe) {
      setActiveIndex(prev => (prev - 1 + featuredWorks.length) % featuredWorks.length);
    }
    setTouchStart(0);
    setTouchEnd(0);
  };
  return <section ref={sectionRef} className="relative w-full h-screen flex items-center justify-center overflow-hidden hero-section" data-id="element-177">
      <div className="absolute inset-0 bg-black z-0" data-id="element-178">
        {(!isMobile || !isReducedMotion) && <video ref={videoRef} className="absolute inset-0 w-full h-full object-cover opacity-25" autoPlay muted loop playsInline preload="auto" data-id="element-179">
            <source src="https://assets.mixkit.co/videos/preview/mixkit-set-of-plateaus-seen-from-the-heights-in-a-sunset-26070-large.mp4" type="video/mp4" data-id="element-180" />
          </video>}
        {(isMobile || isReducedMotion) && <div className="absolute inset-0 bg-gradient-to-b from-gray-900 to-black opacity-80" data-id="element-181"></div>}
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 to-black/80 z-5" data-id="element-182"></div>
        {!isMobile && <div className="absolute inset-0 z-10 pointer-events-none overflow-hidden" data-id="element-183">
            <div ref={logoRef} className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl" data-id="element-184">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jJy59TMDp1yB3h9h9tuSsL/LOGO_BLUEsmall.png" alt="Blue Rain Productions Logo Watermark" className="w-full opacity-[0.15] filter drop-shadow-[0_0_15px_rgba(37,99,235,0.4)]" loading="lazy" data-id="element-185" />
            </div>
          </div>}
        {!isMobile && !isReducedMotion && <div ref={rainRef} className="absolute inset-0 z-10 pointer-events-none" data-id="element-186"></div>}
      </div>
      <div className="container mx-auto px-4 relative z-20" data-id="element-187">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 md:gap-12" data-id="element-188">
          <div className={`w-full md:w-1/2 text-center md:text-left transition-all duration-700 ${isVisible ? 'opacity-100' : 'opacity-0'}`} data-id="element-189">
            <div className="relative mb-6 md:mb-8 px-4 md:px-0" data-id="element-190">
              <div className="hidden md:block absolute -left-4 top-0 bottom-0 w-1 bg-blue-600 rounded-full" data-id="element-191"></div>
              <div className="md:hidden mx-auto w-12 h-1 bg-blue-600 rounded-full mb-4" data-id="element-192"></div>
              <div className="inline-block mb-4 p-1.5 px-3 bg-blue-900/20 border border-blue-800/30 rounded-full backdrop-blur-sm" data-id="element-193">
                <span className="text-blue-400 text-sm font-medium" data-id="element-194">
                  Film & TV Producties
                </span>
              </div>
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6 leading-tight tracking-tighter" data-id="element-195">
                <span className="relative inline-block" data-id="element-196">
                  BLUE <span className="text-blue-400" data-id="element-197">RAIN</span>
                  <span className="absolute -bottom-2 left-0 w-full h-1 bg-blue-600/50 rounded-full" data-id="element-198"></span>
                </span>{' '}
                <br data-id="element-199" />
                PRODUCTIONS
              </h1>
              <p className="text-lg md:text-xl mb-6 md:mb-10 text-gray-300 max-w-xl" data-id="element-200">
                <span className="font-semibold text-white" data-id="element-201">
                  Van creatief idee tot perfecte uitvoering
                </span>{' '}
                wij zorgen dat uw productie tot in detail wordt verzorgd met
                professionele expertise en toewijding.
              </p>
            </div>
            <div className="flex flex-wrap justify-center md:justify-start gap-3 md:gap-4" data-id="element-202">
              <button onClick={() => document.getElementById('portfolio')?.scrollIntoView({
              behavior: isReducedMotion ? 'auto' : 'smooth'
            })} className="bg-transparent hover:bg-blue-600 text-white px-5 sm:px-6 py-2.5 border-2 border-white hover:border-blue-600 rounded-sm transition-colors duration-300 text-base font-medium group flex items-center" data-id="element-203">
                Bekijk portfolio
                <svg className="ml-2 w-5 h-5 transform transition-transform group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-204">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-205" />
                </svg>
              </button>
              <button onClick={() => document.getElementById('contact')?.scrollIntoView({
              behavior: isReducedMotion ? 'auto' : 'smooth'
            })} className="bg-blue-600 hover:bg-blue-700 text-white px-5 sm:px-6 py-2.5 border-2 border-blue-600 hover:border-blue-700 rounded-sm transition-colors duration-300 text-base font-medium" data-id="element-206">
                Contact opnemen
              </button>
            </div>
          </div>
          <div className={`w-full md:w-1/2 mt-6 md:mt-0 transition-all duration-700 delay-200 ${isVisible ? 'opacity-100' : 'opacity-0'}`} onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)} data-id="element-207">
            <div className="relative rounded-sm overflow-hidden shadow-lg" data-id="element-208">
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent z-10" data-id="element-209"></div>
              <div className="relative aspect-video w-full overflow-hidden" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} data-id="element-210">
                {featuredWorks.map((work, index) => <div key={work.id} className={`absolute inset-0 transition-opacity duration-500 ${index === activeIndex ? 'opacity-100 z-5' : 'opacity-0 z-0'}`} aria-hidden={index !== activeIndex} data-id="element-211">
                    <img src={work.thumbnail} alt={`${work.title} - Blue Rain Productions`} className="w-full h-full object-cover" loading={index === activeIndex ? 'eager' : 'lazy'} data-id="element-212" />
                  </div>)}
                <button onClick={() => openVideo(featuredWorks[activeIndex].id, featuredWorks[activeIndex].title)} className="absolute inset-0 z-20 flex items-center justify-center" aria-label="Play video" data-id="element-213">
                  <div className="w-16 h-16 sm:w-18 sm:h-18 rounded-full bg-blue-600/80 backdrop-blur-sm flex items-center justify-center transition-transform duration-300 hover:scale-110 shadow-lg" data-id="element-214">
                    <PlayIcon size={isMobile ? 28 : 32} className="text-white ml-1" data-id="element-215" />
                  </div>
                </button>
                <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-5 z-20 text-left" data-id="element-216">
                  <div className="max-w-[90%]" data-id="element-217">
                    <span className="text-blue-400 text-xs sm:text-sm font-medium inline-block mb-1 sm:mb-2 px-2 py-0.5 bg-blue-900/30 rounded-sm" data-id="element-218">
                      {featuredWorks[activeIndex].category}
                    </span>
                    <h3 className="text-base sm:text-xl font-bold text-white line-clamp-2 text-shadow" data-id="element-219">
                      {featuredWorks[activeIndex].title}
                    </h3>
                  </div>
                </div>
              </div>
              <div className="absolute bottom-4 right-0 left-0 z-30 flex justify-center md:justify-end md:right-4 md:left-auto space-x-2" data-id="element-220">
                {featuredWorks.map((_, index) => <button key={index} onClick={() => setActiveIndex(index)} className={`h-1.5 sm:h-2 rounded-full transition-all ${index === activeIndex ? 'bg-blue-500 w-6 sm:w-8' : 'bg-white/50 hover:bg-white/70 w-1.5 sm:w-2'}`} aria-label={`Go to slide ${index + 1}`} aria-current={index === activeIndex ? 'true' : 'false'} data-id="element-221" />)}
              </div>
              <div className="absolute inset-0 z-20 flex items-center justify-between pointer-events-none" data-id="element-222">
                <button onClick={e => {
                e.stopPropagation();
                setActiveIndex(prev => (prev - 1 + featuredWorks.length) % featuredWorks.length);
              }} className="p-2 text-white/70 hover:text-white transition-colors bg-black/20 hover:bg-black/40 rounded-full ml-2 pointer-events-auto" aria-label="Previous slide" data-id="element-223">
                  <svg width={isMobile ? '16' : '20'} height={isMobile ? '16' : '20'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-224">
                    <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-225" />
                  </svg>
                </button>
                <button onClick={e => {
                e.stopPropagation();
                setActiveIndex(prev => (prev + 1) % featuredWorks.length);
              }} className="p-2 text-white/70 hover:text-white transition-colors bg-black/20 hover:bg-black/40 rounded-full mr-2 pointer-events-auto" aria-label="Next slide" data-id="element-226">
                  <svg width={isMobile ? '16' : '20'} height={isMobile ? '16' : '20'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-227">
                    <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-228" />
                  </svg>
                </button>
              </div>
            </div>
            <div className="block sm:hidden mt-3 mx-auto w-full bg-gray-800 h-1 rounded-full overflow-hidden" data-id="element-229">
              <div className="h-full bg-blue-500 transition-all duration-300 ease-out" style={{
              width: `${activeIndex / (featuredWorks.length - 1) * 100}%`
            }} data-id="element-230"></div>
            </div>
            <div className="hidden md:flex justify-between items-center mt-3" data-id="element-231">
              <div className="text-sm text-gray-300" data-id="element-232">
                {`${activeIndex + 1} / ${featuredWorks.length}`}
              </div>
              <div className="flex gap-2" data-id="element-233">
                <button onClick={() => setActiveIndex(prev => (prev - 1 + featuredWorks.length) % featuredWorks.length)} className="p-2 text-white/70 hover:text-white transition-colors" aria-label="Previous slide" data-id="element-234">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-235">
                    <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-236" />
                  </svg>
                </button>
                <button onClick={() => setActiveIndex(prev => (prev + 1) % featuredWorks.length)} className="p-2 text-white/70 hover:text-white transition-colors" aria-label="Next slide" data-id="element-237">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-238">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-239" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 z-20" data-id="element-240">
        <ChevronDownIcon size={isMobile ? 24 : 30} className="text-white/70 animate-pulse-slow" data-id="element-241" />
      </div>
      <style jsx data-id="element-242">{`
        @keyframes raindrop {
          0% {
            transform: translateY(-20vh);
            opacity: 0;
          }
          20% {
            opacity: 0.1;
          }
          80% {
            opacity: 0.1;
          }
          100% {
            transform: translateY(100vh);
            opacity: 0;
          }
        }
        .raindrop {
          position: absolute;
          top: -20px;
          background: linear-gradient(
            to bottom,
            rgba(59, 130, 246, 0.01),
            rgba(59, 130, 246, 0.15)
          );
          height: 15px;
          border-radius: 0 0 2px 2px;
          animation: raindrop linear infinite;
          z-index: 5;
        }
        .text-shadow {
          text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
        }
      `}</style>
    </section>;
};